import Vue from 'vue'
import Router from 'vue-router'
import DashboardComponent from '@/components/DashboardComponent.vue'
import DashboardHHComponent from '@/components/DashboardHHComponent.vue'
import LoginComponent from '@/components/accounts/LoginComponent.vue'
import SharedRoutes from '@/routers/shared'
import CatRoutes from '@/routers/catalogos'
import ComprasRoutes from '@/routers/compras'
import UsuariosRoutes from '@/routers/usuarios'
import TareasRoutes from '@/routers/tareas'
import TrasladoRoutes from '@/routers/inventario'
import cxcRoutes from '@/routers/cxc'
import cxpRoutes from '@/routers/cxp'
import contaRoutes from '@/routers/conta'
import wmsReoutes from '@/routers/wms'
import bancosReoutes from '@/routers/bancos'
import posRoutes from '@/routers/pos'
import talleresRoutes from '@/routers/talleres'
import afRoutes from '@/routers/af'
import rrhhRoutes from '@/routers/rrhh'
import Notifications from "@/notifications/notifications";


Vue.use(Router)


let defaultRouters = [{
    path: '/',
    name: 'dashboard',
    component: DashboardComponent,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/accounts/login',
    name: 'login',
    component: LoginComponent,
    meta: {
      requiresAuth: false
    }
  },

]
let routers = defaultRouters.concat(SharedRoutes)
routers = routers.concat(CatRoutes)
routers = routers.concat(ComprasRoutes)
routers = routers.concat(UsuariosRoutes)
routers = routers.concat(TareasRoutes)
routers = routers.concat(TrasladoRoutes)
routers = routers.concat(cxcRoutes)
routers = routers.concat(cxpRoutes)
routers = routers.concat(contaRoutes)
routers = routers.concat(wmsReoutes)
routers = routers.concat(bancosReoutes)
routers = routers.concat(posRoutes)
routers = routers.concat(talleresRoutes)
routers = routers.concat(afRoutes)
routers = routers.concat(rrhhRoutes)

let router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routers
})


router.beforeEach((to, from, next) => {
  if ($(".menu-mobile .menu-and-user").is(":visible")) {
    $('.menu-mobile .menu-and-user').slideUp(200, 'swing');
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      let _nexturl = localStorage.getItem("nexturl");
      if (to.fullPath == _nexturl){
        localStorage.setItem("nexturl", '/');
      }else{
        localStorage.setItem("nexturl", to.fullPath);
      }
      
      next({
        path: '/accounts/login',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))
      let nextUrl = false;
      if (to.matched.some(record => record.meta.requiresAuth)) {
        let is_superuser = localStorage.getItem('is_superuser')
        let permisos = JSON.parse(localStorage.getItem('permisos'))
        nextUrl = is_superuser;
        if (!nextUrl) {
          if (to.meta.permission == '' || to.meta.permission == null) {
            nextUrl = true;
          } else {
            if (permisos != null) {
              nextUrl = permisos.find(permiso => permiso.codename === to.meta.permission);
            }
          }
        }
      }
      if (nextUrl) {
        next()
      } else {
        Notifications.alert.error(
          "Permisos",
          "No Posee permisos para realizar esta acción"
        );
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: 'dashboard'
      })
    }
  } else {
    next()
  }
})

export default router;